export default __webpack_public_path__ + "static/media/07en.ac923f40.mp3";